// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c6fbbed4","455":"ac467da7","977":"164c5f9b"}[chunkId] + ".chunk.js";
};